import React, { useState, useEffect, useContext } from 'react';
import {
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Box,
  Typography,
  Snackbar,
  Alert,
  InputAdornment,
  OutlinedInput,
  Autocomplete,
  Chip,
  CircularProgress,
} from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import SportsFootballOutlinedIcon from '@mui/icons-material/SportsFootballOutlined';
import useAxiosConfig from '../config/AxiosConfig';
import { AuthContext } from '../auth/ContextAuthentication';

const initialValues = {
  code: '',
  discount: '',
  city: '',
  groundIds: [],
  startDate: '',
  expiryDate: '',
  startTime: '',
  endTime: '',
  appliesToAllGrounds: false,
};

const cityOptions = [
  { label: 'All', value: 'All' },
  { label: 'ISB/RWP', value: 'ISB/RWP' },
  { label: 'Lahore', value: 'Lahore' },
  { label: 'Karachi', value: 'Karachi' },
  { label: 'Peshawar', value: 'Peshawar' },
  { label: 'Faisalabad', value: 'Faisalabad' },
];

const CreatePromoForm = ({ title, onSubmit }) => {
  const [promotionValues, setPromotionValues] = useState(initialValues);
  const [validationError, setValidationError] = useState('');
  const [allGrounds, setAllGrounds] = useState([]);
  const [grounds, setGrounds] = useState([]);
  const [isLoadingGrounds, setIsLoadingGrounds] = useState(false);
  const { promotions } = useContext(AuthContext);
  const { selectedPromotionID, setSelectedPromotionID } =
    useContext(AuthContext);
  const { editPromotion, setEditPromotion } = useContext(AuthContext);

  const axiosInstance = useAxiosConfig();

  useEffect(() => {
    fetchGrounds();
  }, []);

  // Filter grounds based on selected city
  useEffect(() => {
    if (!promotionValues.city || promotionValues.city === '') {
      // If city is empty, show all grounds (including those with empty city)
      setGrounds(allGrounds);
    } else {
      // Filter grounds by selected city, also include grounds with empty city ('')
      const filteredGrounds = allGrounds.filter(
        ground =>
          ground.city === promotionValues.city ||
          ground.city === '' ||
          !ground.city,
      );
      setGrounds(filteredGrounds);
    }
  }, [promotionValues.city, allGrounds]);

  useEffect(() => {
    console.log(';testinggggggg', promotions);
  }, [promotions]);

  useEffect(() => {
    console.log('heeeeeeeeeeeee', promotionValues);
  }, [promotionValues]);

  useEffect(() => {
    if (!editPromotion) {
      setSelectedPromotionID(null);
    }
  }, [editPromotion]);

  useEffect(() => {
    const result = promotions.find(promo => promo._id === selectedPromotionID);
    if (result) {
      setPromotionValues({
        code: result.code || '',
        discount: result.discount || '',
        city: result.city || '',
        groundIds: !result.appliesToAllGrounds
          ? result.groundIds
          : 'All Grounds',
        startDate: result.startDate ? formatDate(result.startDate) : '',
        expiryDate: result.expiryDate ? formatDate(result.expiryDate) : '',
        startTime: result.startTime || '',
        endTime: result.endTime || '',
      });
    } else {
      setPromotionValues(initialValues);
    }
  }, [promotions, selectedPromotionID]);

  const allGroundsOption = {
    _id: 'all-grounds',
    name: 'All Grounds',
    isAllGrounds: true,
  };

  const handleCityFilterChange = (event, newValue) => {
    console.log('newValue', newValue);
    if (newValue) {
      // If "All" is selected, set city to empty string to show all grounds
      const cityValue = newValue.value === 'All' ? '' : newValue.value;
      setPromotionValues(prev => ({
        ...prev,
        city: cityValue,
      }));
    } else {
      // Clear city when nothing is selected
      setPromotionValues(prev => ({
        ...prev,
        city: '',
      }));
    }
  };

  const formatDate = date => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const fetchGrounds = async () => {
    setIsLoadingGrounds(true);
    try {
      const response = await axiosInstance.get(
        '/api/admin/get-all-bookings-grounds?filter=all',
      );
      console.log('grounds', response.data.data);

      setAllGrounds(response.data.data);
      setGrounds(response.data.data);
    } catch (error) {
      console.error('Error fetching grounds:', error);
    } finally {
      setIsLoadingGrounds(false);
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setValidationError('');

    const { startTime, endTime } = promotionValues;

    // If one time is selected, the other must also be selected
    const hasStartTime = startTime && startTime.trim() !== '';
    const hasEndTime = endTime && endTime.trim() !== '';
    if (hasStartTime && !hasEndTime) {
      setValidationError('End time is required when start time is selected');
      return;
    }
    if (!hasStartTime && hasEndTime) {
      setValidationError('Start time is required when end time is selected');
      return;
    }

    // End time must be greater than start time
    if (hasStartTime && hasEndTime) {
      if (endTime <= startTime) {
        setValidationError('End time must be greater than start time');
        return;
      }
    }

    const payload = { ...promotionValues };
    if (!hasStartTime && !hasEndTime) {
      delete payload.startTime;
      delete payload.endTime;
    }

    await onSubmit(payload);
    setPromotionValues(initialValues);
    setEditPromotion(false);
  };

  const handleChange = e => {
    setPromotionValues(prev => {
      return {
        ...prev,
        [e.target.name]:
          e.target.name === 'code'
            ? e.target.value.toUpperCase()
            : e.target.value,
      };
    });
  };

  const handleKeyPress = e => {
    const charCode = e.which || e.keyCode;
    const char = String.fromCharCode(charCode);
    const currentValue = e.target.value;

    // Allow control keys (backspace, delete, tab, escape, enter, arrows)
    const controlKeys = [8, 9, 27, 13, 37, 38, 39, 40, 46];
    if (controlKeys.includes(charCode)) {
      return;
    }

    // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    if (e.ctrlKey || e.metaKey) {
      return;
    }

    // Only allow digits and one decimal point
    if (!/[\d.]/.test(char)) {
      e.preventDefault();
      return;
    }

    // Prevent multiple decimal points
    if (char === '.' && currentValue.includes('.')) {
      e.preventDefault();
      return;
    }

    // Prevent numbers greater than 100
    const newValue = currentValue + char;
    if (parseFloat(newValue) > 100) {
      e.preventDefault();
      return;
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 400,
        mx: 'auto',
        p: 2,
        boxShadow: 3,
        borderRadius: 2,
        my: 'auto',
      }}>
      <Typography variant="h6" sx={{ mb: 2, textAlign: 'center' }}>
        {title}
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Promo Name"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <DescriptionOutlinedIcon />
              </InputAdornment>
            ),
          }}
          name="code"
          value={promotionValues.code}
          onChange={handleChange}
          margin="normal"
          required
        />
        <TextField
          fullWidth
          label="Enter % off"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LocalOfferOutlinedIcon />
              </InputAdornment>
            ),
          }}
          inputProps={{
            pattern: '^(100|[1-9]?[0-9])$', // 0-100
            min: 0,
            max: 100,
          }}
          type="number"
          name="discount"
          value={promotionValues.discount}
          onChange={handleChange}
          onKeyPress={handleKeyPress}
          margin="normal"
          required
        />

        <Autocomplete
          options={cityOptions}
          getOptionLabel={option => option.label}
          style={{ width: 370, paddingBottom: '16px', paddingTop: '8px' }}
          renderInput={params => (
            <TextField
              {...params}
              label="City"
              InputProps={{
                ...params.InputProps,
              }}
            />
          )}
          onChange={handleCityFilterChange}
          value={
            cityOptions.find(option => option.value === promotionValues.city) ||
            null
          }
        />

        {/* here */}
        <Autocomplete
          multiple
          options={[allGroundsOption, ...grounds]}
          getOptionLabel={option => option.name || ''}
          isOptionEqualToValue={(option, value) => {
            if (option.isAllGrounds && value.isAllGrounds) return true;
            return option._id === value._id;
          }}
          value={
            promotionValues.appliesToAllGrounds
              ? [allGroundsOption]
              : grounds.filter(
                  ground =>
                    Array.isArray(promotionValues.groundIds) &&
                    promotionValues.groundIds.includes(ground._id),
                )
          }
          onChange={(event, newValue) => {
            const includesAllGrounds = newValue.some(item => item.isAllGrounds);

            if (includesAllGrounds) {
              setPromotionValues(prev => ({
                ...prev,
                appliesToAllGrounds: true,
                groundIds: [],
              }));
            } else {
              setPromotionValues(prev => ({
                ...prev,
                groundIds: newValue.map(item => item._id),
                appliesToAllGrounds: false,
              }));
            }
          }}
          loading={isLoadingGrounds}
          renderInput={params => (
            <TextField
              {...params}
              label="Choose grounds"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <>
                    <InputAdornment position="start">
                      <LocationOnOutlinedIcon />
                    </InputAdornment>
                    {isLoadingGrounds ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.startAdornment}
                  </>
                ),
              }}
            />
          )}
        />

        <TextField
          fullWidth
          label="Start Date"
          type="date"
          name="startDate"
          value={promotionValues.startDate}
          onChange={handleChange}
          margin="normal"
          InputLabelProps={{ shrink: true }}
          required
        />
        <TextField
          fullWidth
          label="Expiration Date"
          type="date"
          name="expiryDate"
          value={promotionValues.expiryDate}
          onChange={handleChange}
          margin="normal"
          InputLabelProps={{ shrink: true }}
          required
        />

        <TextField
          fullWidth
          label="Start Time (24h)"
          type="time"
          name="startTime"
          value={promotionValues.startTime}
          onChange={handleChange}
          margin="normal"
          InputLabelProps={{ shrink: true }}
          inputProps={{ step: 300 }}
          helperText="Optional - valid daily within this time range"
        />
        <TextField
          fullWidth
          label="End Time (24h)"
          type="time"
          name="endTime"
          value={promotionValues.endTime}
          onChange={handleChange}
          margin="normal"
          InputLabelProps={{ shrink: true }}
          inputProps={{ step: 300 }}
          helperText="Optional - required if start time is set"
        />

        <Snackbar
          open={!!validationError}
          autoHideDuration={4000}
          onClose={() => setValidationError('')}
        >
          <Alert
            onClose={() => setValidationError('')}
            severity="error"
            sx={{ width: '100%' }}
          >
            {validationError}
          </Alert>
        </Snackbar>

        <Button
          type="submit"
          variant="contained"
          color="success"
          fullWidth
          sx={{ mt: 2 }}>
          Save
        </Button>
      </form>
    </Box>
  );
};

export default CreatePromoForm;
